import { render, staticRenderFns } from "./ToggleLike.vue?vue&type=template&id=4ed06254&scoped=true"
import script from "./ToggleLike.vue?vue&type=script&lang=ts&setup=true"
export * from "./ToggleLike.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ToggleLike.vue?vue&type=style&index=0&id=4ed06254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed06254",
  null
  
)

export default component.exports